import type { PropsWithChildren } from "react";

import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "../components/ErrorFallback";
import type { IWidgetCardLayoutProps } from "../components/WidgetCardLayout";
import { WidgetCardLayout } from "../components/WidgetCardLayout";

export const WidgetCard = ({ children, ...other }: PropsWithChildren<IWidgetCardLayoutProps>) => {
    const fallback = (
        <ErrorFallback
            {...other}
            minHeight="280px"
        />
    );

    return (
        <ErrorBoundary fallback={fallback}>
            <WidgetCardLayout
                {...other}
                minHeight="280px"
            >
                {children}
            </WidgetCardLayout>
        </ErrorBoundary>
    );
};
